const getModuleAppId = (moduleName = '') => {
	let weparkModuleAppId = {
		'crm-management':104 //客户模块
	}
	if(window.envType === 'wepark'){
		return (moduleName in weparkModuleAppId) ? weparkModuleAppId[moduleName]:''
	}
	try {
		if (moduleName) {
			const activeModules = JSON.parse(localStorage.getItem('active_modules'));
			const module = activeModules.find(value => value.key === moduleName);
			return module.appId;
		}
	} catch (msg) {}
};

export default getModuleAppId;
